export default {"src":"/_next/static/media/aboutBG.a48afcf6.svg","height":1562,"width":2135,"blurWidth":0,"blurHeight":0};